function initCustomizableProduct() {
        // Validación principal
        function validarFormulario() {
          let valid = true;
          const tipo = document.querySelector('input[name="tipo-nombre-numero"]:checked');
          if (!tipo) {
            errorTipo.classList.remove('hidden');
            valid = false;
          } else {
            errorTipo.classList.add('hidden');
            if (['jugadores', 'jugadoras', 'porteros', 'porteras'].includes(tipo.value)) {
              if (!selectJugadorDinamico || !selectJugadorDinamico.value) {
                errorJugador.classList.remove('hidden');
                valid = false;
              } else {
                errorJugador.classList.add('hidden');
              }
              // No validar nombre/numero propios
              errorPropioNombre.classList.add('hidden');
              errorPropioNumero.classList.add('hidden');
            } else if (tipo.value === 'propio') {
              if (!inputNombre.value.trim()) {
                errorPropioNombre.classList.remove('hidden');
                valid = false;
              } else {
                errorPropioNombre.classList.add('hidden');
              }
              const num = inputNumero.value.trim();
              if (!/^\d{1,2}$/.test(num) || parseInt(num) < 1 || parseInt(num) > 99) {
                errorPropioNumero.classList.remove('hidden');
                valid = false;
              } else {
                errorPropioNumero.classList.add('hidden');
              }
              // No validar select jugador
              errorJugador.classList.add('hidden');
            }
          }
          habilitarAddToCart(valid && formulario && !formulario.classList.contains('hidden'));
        }
    // Elementos
    const btnSinDorsal = document.getElementById('btn-sin-dorsal');
    const btnPersonalizada = document.getElementById('btn-personalizada');
    const formulario = document.getElementById('form-personalizada');
    if (!formulario) {
      console.warn('No se encontró el formulario de personalización.');
      return;
    }
    const radiosTipo = document.querySelectorAll('.radio-tipo-nombre-numero');
    const grupoJugador = document.getElementById('grupo-jugador');
    const grupoPropio = document.getElementById('grupo-propio');
    const selectJugadorDinamico = document.getElementById('select-jugador-dinamico');
    const inputNombre = document.getElementById('input-propio-nombre');
    const inputNumero = document.getElementById('input-propio-numero');
  
    // Errores
    const errorTipo = document.getElementById('error-tipo-nombre-numero');
    const errorJugador = document.getElementById('error-jugador');
    const errorPropioNombre = document.getElementById('error-propio-nombre');
    //const errorPropioNumero = document.getElementById('error-propio-numero');
    const errorPropioNumero = "";
  
    // Botón nativo de Shopify (Add to cart)
    const addToCartBtn = document.querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[type="submit"]');
  
    // Mostrar/ocultar formulario

    btnSinDorsal.addEventListener('click', function () {
      formulario.classList.add('hidden');
      btnSinDorsal.classList.add('bg-gray-300');
      btnPersonalizada.classList.remove('bg-blue-600','shadow');
      btnPersonalizada.classList.add('bg-blue-500');
      habilitarAddToCart(true); // Habilita el botón carrito
      if (addToCartBtn) addToCartBtn.disabled = false;
    });

    btnPersonalizada.addEventListener('click', function () {
      formulario.classList.remove('hidden');
      btnPersonalizada.classList.add('bg-blue-600','shadow');
      btnPersonalizada.classList.remove('bg-blue-500');
      btnSinDorsal.classList.remove('bg-gray-300');
      validarFormulario(); // Valida al mostrar
      if (addToCartBtn) addToCartBtn.disabled = true; // Deshabilita el botón nativo
    });
  
    // Lógica para mostrar campos según radio
    radiosTipo.forEach(radio => {
      radio.addEventListener('change', function () {
        if (this.value === 'jugador') {
          grupoJugador.classList.remove('hidden');
          grupoPropio.classList.add('hidden');
        } else if (this.value === 'propio') {
          grupoJugador.classList.add('hidden');
          grupoPropio.classList.remove('hidden');
        }
        validarFormulario();
      });
    });
  
    // Validación de campos obligatorios al cambiar
    [selectJugadorDinamico, inputNombre, inputNumero].forEach(el => {
      if (el) {
        el.addEventListener('input', validarFormulario);
        el.addEventListener('change', validarFormulario);
      }
    });
  
    // Validación principal
    function validarFormulario() {
      let valid = true;
      // Validar tipo
      const tipo = document.querySelector('input[name="tipo-nombre-numero"]:checked');
      if (!tipo) {
        errorTipo.classList.remove('hidden');
        valid = false;
      } else {
        errorTipo.classList.add('hidden');
        if (tipo.value === 'jugador') {
          // Debe seleccionar jugador
          let hasJugadorSelected = false;
          if (selectJugadores && selectJugadores.value) hasJugadorSelected = true;
          else if (selectJugadoras && selectJugadoras.value) hasJugadorSelected = true;
          else if (selectPorteros && selectPorteros.value) hasJugadorSelected = true;
          else if (selectPorteras && selectPorteras.value) hasJugadorSelected = true;

          if (!hasJugadorSelected) {
            errorJugador.classList.remove('hidden');
            valid = false;
          } else {
            errorJugador.classList.add('hidden');
          }
        } else if (tipo.value === 'propio') {
          // Debe rellenar nombre y número
          if (!inputNombre.value.trim()) {
            errorPropioNombre.classList.remove('hidden');
            valid = false;
          } else {
            errorPropioNombre.classList.add('hidden');
          }
          // Validar número (1-99)
          const num = inputNumero.value.trim();
          if (!/^\d{1,2}$/.test(num) || parseInt(num) < 1 || parseInt(num) > 99) {
            errorPropioNumero.classList.remove('hidden');
            valid = false;
          } else {
            errorPropioNumero.classList.add('hidden');
          }
        }
      }
      habilitarAddToCart(valid && formulario && !formulario.classList.contains('hidden'));
    }
  
    // Habilitar/deshabilitar botón nativo de añadir al carrito
    function habilitarAddToCart(habilitar) {
      if (!addToCartBtn) return;
      addToCartBtn.disabled = !habilitar;
      if (!habilitar) {
        addToCartBtn.classList.add('opacity-50', 'cursor-not-allowed');
      } else {
        addToCartBtn.classList.remove('opacity-50', 'cursor-not-allowed');
      }
    }
  
    // --- Lógica para obtener valores y añadir al carrito ---
    // Utilidad para obtener incremento de precio de jugador
    function getJugadorSeleccionado() {
      if (!selectJugadorDinamico || !selectJugadorDinamico.value) return null;

      const option = selectJugadorDinamico.options[selectJugadorDinamico.selectedIndex];
      if (!option || !option.value) return null;
      return {
        nombre: option.getAttribute('data-nombre'),
        dorsal: option.getAttribute('data-dorsal'),
        precio: parseFloat(option.getAttribute('data-price')) || 0,
        sku: option.getAttribute('data-sku') || ''
      };
    }

    // Utilidad para obtener datos de personalización propia
    function getPropioSeleccionado() {
      return {
        nombre: inputNombre.value.trim(),
        dorsal: inputNumero.value.trim(),
        precio: parseFloat(inputNombre.getAttribute('data-price')) + parseFloat(inputNumero.getAttribute('data-price')) || 0,
        skuNombre: inputNombre.getAttribute('data-sku') || '',
        skuNumero: inputNumero.getAttribute('data-sku') || ''
      };
    }

    // Añadir al carrito con propiedades personalizadas
    async function addToCart(productId, properties) {
      const data = {
        id: productId,
        quantity: 1,
        properties: properties
      };
      console.log('Añadiendo al carrito:', data); // Log para depuración
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      if (res.ok) {
        // Mostrar el mini cart lateral y recargar su contenido usando Alpine.js
        if (window.Alpine && Alpine.store && Alpine.store('xMiniCart')) {
          if (typeof Alpine.store('xMiniCart').openCart === 'function') {
            Alpine.store('xMiniCart').openCart();
          }
          if (typeof Alpine.store('xMiniCart').reLoad === 'function') {
            Alpine.store('xMiniCart').reLoad();
          }
        } else {
          // Fallback: recarga la página del carrito si Alpine no está disponible
          window.location.href = '/cart';
        }
      } else {
        alert('Error al añadir al carrito');
      }
    }

    // Interceptar el submit del formulario personalizado
    formulario.addEventListener('submit', async function (e) {
      console.log('Evento submit capturado');
      e.preventDefault();
      const tipo = document.querySelector('input[name="tipo-nombre-numero"]:checked').value;
      let properties = {};
      let priceIncrement = 0;
      if (tipo === 'jugador') {
        const jugador = getJugadorSeleccionado();
        if (!jugador) return alert('Selecciona un jugador válido.');
        if (jugador.nombre) properties['Nombre'] = jugador.nombre;
        if (jugador.dorsal) properties['Dorsal'] = jugador.dorsal;
        properties['Tipo'] = 'Jugador';
        if (jugador.precio) properties['Incremento'] = jugador.precio + ' €';
        if (jugador.sku) properties['SKU Jugador'] = jugador.sku;
        priceIncrement = jugador.precio;
      } else {
        const propio = getPropioSeleccionado();
        if (!propio.nombre || !propio.dorsal) return alert('Introduce nombre y dorsal.');
        if (propio.nombre) properties['Nombre'] = propio.nombre;
        if (propio.dorsal) properties['Dorsal'] = propio.dorsal;
        if (propio.skuNombre) properties['SKU Nombre'] = propio.skuNombre;
        if (propio.skuNumero) properties['SKU Número'] = propio.skuNumero;
        properties['Tipo'] = 'Propio';
        if (propio.precio) properties['Incremento'] = propio.precio + ' €';
        priceIncrement = propio.precio;
      }
      // Verifica que las properties no estén vacías
      if (Object.keys(properties).length === 0) {
        alert('No se han detectado datos de personalización.');
        return;
      }
      // Obtén el ID del producto (puedes pasarlo como variable global o data-attribute)
      let productId = window.customizableProductId;
      if (!productId) {
        const section = document.getElementById('customizable-product');
        if (section && section.dataset.productId) {
          productId = section.dataset.productId;
        } else {
          productId = document.querySelector('[data-product-id]')?.getAttribute('data-product-id');
        }
      }
      if (!productId) return alert('No se ha encontrado el producto.');
      await addToCart(productId, properties);
    });


    // Actualizar el precio final mostrado en la PDP
    function actualizarPrecioFinal() {
      const precioBaseEl = document.getElementById('precio-final-pdp');
      if (!precioBaseEl) return;
      const base = parseFloat(precioBaseEl.getAttribute('data-base-price')) || 0;
      let incremento = 0;
      const tipo = document.querySelector('input[name="tipo-nombre-numero"]:checked');
      if (tipo) {
        if (tipo.value === 'jugador') {
          const jugador = getJugadorSeleccionado();
          if (jugador) incremento = jugador.precio;
        } else if (tipo.value === 'propio') {
          const propio = getPropioSeleccionado();
          if (propio) incremento = propio.precio;
        }
      }
      const total = base + incremento;
      // Formatear como moneda EUR
      precioBaseEl.textContent = total.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    }

    // Eventos para recalcular precio
    if (selectJugadorDinamico) selectJugadorDinamico.addEventListener('change', actualizarPrecioFinal);
    radiosTipo.forEach(radio => radio.addEventListener('change', actualizarPrecioFinal));
    inputNombre.addEventListener('input', actualizarPrecioFinal);
    inputNumero.addEventListener('input', actualizarPrecioFinal);

    // Inicializar precio al cargar
    actualizarPrecioFinal();

    // Validar al iniciar
    validarFormulario();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomizableProduct);
} else {
  initCustomizableProduct();
}